import type { Loan } from 'app/types/loan';

/** Returns the reference date for a past loan (when it concluded). */
export function getTimelineLoanCardDate(returned: Loan['returned'], end: Loan['end']): Date {
  return new Date(returned ?? end);
}

/** Utility to check if two loans fall in different months. Used by the list to compute isNewMonth. */
export function isTimelineLoanCardNewMonth(current: Loan, previous?: Loan): boolean {
  if (!previous) return true;
  const currentDate = getTimelineLoanCardDate(current.returned, current.end);
  const previousDate = getTimelineLoanCardDate(previous.returned, previous.end);
  return currentDate.getMonth() !== previousDate.getMonth() || currentDate.getFullYear() !== previousDate.getFullYear();
}
